var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1634(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.236,
    height: 15,
    viewBox: "0 0 15.236 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(355.13 -107.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M-349.884,248.872a2.934,2.934,0,0,1,1.233-1.955,2.749,2.749,0,0,1,3.49.244,3.5,3.5,0,0,1,1.208,3.157,7.686,7.686,0,0,1-1.481,3.642,11.643,11.643,0,0,1-1.96,2.192,1.348,1.348,0,0,1-1.305.328,10.858,10.858,0,0,1-4.9-2.528,4.713,4.713,0,0,1-1.448-2.356,3.372,3.372,0,0,1,1.293-3.471,2.889,2.889,0,0,1,3.634.488C-350.045,248.691-349.976,248.769-349.884,248.872Z",
    transform: "translate(0 -133.927)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    d: "M-210.5,112.73a3.88,3.88,0,0,1-.263-3.381,2.849,2.849,0,0,1,1.932-1.677,2.548,2.548,0,0,1,2.755,1.222c.114.194.2.406.289.6a6.313,6.313,0,0,1,.509-.575,2.5,2.5,0,0,1,3.966.625,3.151,3.151,0,0,1,0,3.225,6.8,6.8,0,0,1-2.117,2.3c-.23.168-.471.322-.72.492-.055-.277-.085-.539-.161-.786a4,4,0,0,0-3.2-2.992,3.263,3.263,0,0,0-2.834.805C-210.388,112.633-210.431,112.672-210.5,112.73Z",
    transform: "translate(-139.026)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1634);
export default __webpack_public_path__ + "static/media/Group 1634.837b69da90a3b48a597ab93f640a0980.svg";
export { ForwardRef as ReactComponent };